import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faBan, 
    faTimes, 
    faShieldAlt,
    faExclamationTriangle,
    faCommentSlash,
    faEyeSlash,
    faUserSlash
} from '@fortawesome/free-solid-svg-icons';
import '../styles/modal.css';

const BlockConfirmModal = ({ show, onClose, onConfirm, userName }) => {
    const [reason, setReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleConfirm = async () => {
        setIsSubmitting(true);
        try {
            await onConfirm(reason);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setReason('');
        onClose();
    };

    if (!show) {
        return null;
    }

    return (
        <div className="modal-overlay report-modal-overlay" onClick={handleClose}>
            <div className="modal-pop report-modal block-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header report-modal-header block-modal-header">
                    <div className="report-modal-title-section">
                        <FontAwesomeIcon icon={faBan} className="report-shield-icon block-icon" />
                        <h2 className="modal-title">Bloquer {userName}</h2>
                    </div>
                    <button className="modal-close report-close-btn" onClick={handleClose} aria-label="Fermer">
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                
                <div className="modal-content-pop report-modal-content">
                    <div className="report-target-info block-warning-info">
                        <p>Êtes-vous sûr de vouloir bloquer <strong>{userName}</strong> ?</p>
                    </div>
                    
                    <div className="block-consequences-section">
                        <div className="block-consequence-card">
                            <div className="block-consequence-icon">
                                <FontAwesomeIcon icon={faCommentSlash} />
                            </div>
                            <div className="block-consequence-text">
                                <strong>Messagerie bloquée</strong>
                                <p>Vous ne pourrez plus envoyer ou recevoir de messages</p>
                            </div>
                        </div>
                        <div className="block-consequence-card">
                            <div className="block-consequence-icon">
                                <FontAwesomeIcon icon={faEyeSlash} />
                            </div>
                            <div className="block-consequence-text">
                                <strong>Annonces masquées</strong>
                                <p>Vous ne verrez plus ses annonces dans les résultats</p>
                            </div>
                        </div>
                        <div className="block-consequence-card">
                            <div className="block-consequence-icon">
                                <FontAwesomeIcon icon={faUserSlash} />
                            </div>
                            <div className="block-consequence-text">
                                <strong>Profil invisible</strong>
                                <p>Il ne pourra plus voir vos annonces ni votre profil</p>
                            </div>
                        </div>
                    </div>

                    <div className="report-form-group">
                        <label className="report-label">
                            Raison du blocage (optionnel)
                        </label>
                        <textarea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Pourquoi bloquez-vous cet utilisateur ? (facultatif)"
                            rows={3}
                            className="report-textarea"
                            maxLength={200}
                        />
                        <span className="report-char-count">{reason.length}/200</span>
                    </div>

                    <div className="report-info-box block-info-box">
                        <FontAwesomeIcon icon={faExclamationTriangle} className="report-info-icon" />
                        <p>Vous pourrez débloquer cet utilisateur à tout moment depuis votre liste d'utilisateurs bloqués.</p>
                    </div>
                </div>
                
                <div className="modal-actions report-modal-actions">
                    <button
                        type="button"
                        className="modal-button report-cancel-btn"
                        onClick={handleClose}
                        disabled={isSubmitting}
                    >
                        Annuler
                    </button>
                    <button
                        type="button"
                        className="modal-button block-confirm-btn"
                        onClick={handleConfirm}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner-small"></span>
                                Blocage...
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faBan} />
                                Bloquer {userName}
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

BlockConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    userName: PropTypes.string.isRequired,
};

export default BlockConfirmModal;
